
import { type ClientProviderPluginInstallOption, type ClientProviderPluginInstallType, type IClientProviderPluginInstaller } from './models/plugin-type'
import { type IFramePluginInstallOption } from './iframe/plugin'
import { type IClientProviderPlugin } from '@source-digital/sd-app-core'
import { type ScriptPluginInstallOption } from './script/plugin-url'
import { type LocalClientPluginInstallOption } from './script/plugin-local'

type ClientProviderPluginInstallOptionType = IFramePluginInstallOption | ScriptPluginInstallOption | LocalClientPluginInstallOption | ClientProviderPluginInstallOption<any>

class ClientProviderPluginLoader {
  installerMap: { [k in string]: IClientProviderPluginInstaller<ClientProviderPluginInstallType> }
  constructor () {
    this.installerMap = {}
  }

  loadedPlugins: Array<{ id: string, name?: string, plugin: IClientProviderPlugin }> = []

  addInstaller (type: ClientProviderPluginInstallType, installer: IClientProviderPluginInstaller<ClientProviderPluginInstallType, any>): this {
    this.installerMap[type] = installer
    return this
  }

  async #loadModule<TYPE extends ClientProviderPluginInstallType>(type: TYPE, config: ClientProviderPluginInstallOption<TYPE>): Promise<{ id: string, name?: string, plugin: IClientProviderPlugin } | undefined> {
    const installer = this.installerMap[type]
    if (installer == null) {
      console.error(`Unknown plugin type: ${config.type}`)
      return undefined
    }
    try {
      return await installer.install(config)
    } catch (e) {
      console.error('Error occurred while loading client plugin', e, { type, config })
      return undefined
    }
  }

  async load (config: ClientProviderPluginInstallOption<ClientProviderPluginInstallType>) {
    const module = await this.#loadModule(config.type, config)
    if (module != null) this.loadedPlugins.push(module)
  }
}

export { ClientProviderPluginLoader }
export type { ClientProviderPluginInstallOptionType }
